const updateItems = [
  { id: 1, title: '《斗罗大陆》', chapter: '第389话', tag: '最新', desc: '唐三双生武魂终极觉醒', time: '10分钟前' },
  { id: 2, title: '《完美世界》', chapter: '第256话', tag: '热门', desc: '石昊横推禁区至尊', time: '25分钟前' },
  { id: 3, title: '《我独自升级》', chapter: '第179话', tag: '完结', desc: '暗影君王最终章', time: '1小时前' },
  { id: 4, title: '《海贼王》', chapter: '第1120话', tag: '热门', desc: '路飞五档 vs 五老星', time: '1小时前' },
  { id: 5, title: '《凡人修仙传》', chapter: '第412话', tag: '最新', desc: '韩立突破大乘期', time: '2小时前' },
  { id: 6, title: '《鬼灭之刃》', chapter: '番外篇', tag: '精选', desc: '炭治郎的日常小剧场', time: '3小时前' },
  { id: 7, title: '《遮天》', chapter: '第198话', tag: '最新', desc: '叶凡踏天路证道', time: '3小时前' },
  { id: 8, title: '《一人之下》', chapter: '第342话', tag: '热门', desc: '张楚岚罗天大醮决战', time: '4小时前' },
  { id: 9, title: '《咒术回战》', chapter: '第271话', tag: '最新', desc: '五条悟领域展开无量空处', time: '5小时前' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3 mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">更新动态</h2>
            <p className="text-foreground-500 text-sm">热门连载最新更新，追更快人一步</p>
          </div>
          <span className="text-sm text-primary-500 font-medium cursor-pointer hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1">
            更多更新 <i className="ri-arrow-right-line"></i>
          </span>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {updateItems.map((item, i) => (
            <div
              key={item.id}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 hover:bg-background-100 transition-colors cursor-pointer ${
                i < updateItems.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <span className="text-xs text-foreground-400 font-medium w-7 shrink-0">
                {String(i + 1).padStart(2, '0')}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-0.5">
                  <h3 className="font-heading text-sm text-foreground-950 whitespace-nowrap">{item.title}</h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.chapter}</span>
                </div>
                <p className="text-foreground-500 text-xs truncate">{item.desc}</p>
              </div>
              <span
                className={`shrink-0 px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                  item.tag === '最新'
                    ? 'bg-primary-100 text-primary-700'
                    : item.tag === '热门'
                      ? 'bg-accent-100 text-accent-700'
                      : item.tag === '完结'
                        ? 'bg-secondary-100 text-secondary-700'
                        : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.tag}
              </span>
              <span className="text-xs text-foreground-400 w-16 text-right shrink-0 hidden sm:block">{item.time}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}